/*
  Tillgänglighet (WCAG 2.2 AA).

  Laddas efter global.min.js och rör inte temats egen logik. Den lägger bara
  till det som tangentbord och skärmläsare saknar. global.min.js är den fil
  som laddas och ska inte redigeras för hand, så rättningarna ligger här i
  stället.
*/
(function () {
  // 2.1.1 Tangentbord: sidfotens menyrubriker reagerar bara på klick. Enter
  // och mellanslag ska göra samma sak. Bara de - temat hanterar redan Enter
  // på t.ex. favorithjärtat, och ett klick till skulle växla tillbaka.
  document.addEventListener("keydown", function (event) {
    if (event.key !== "Enter" && event.key !== " ") return;
    var el = event.target;
    if (!el || !el.classList || !el.classList.contains("footer__dropdown-button")) return;
    event.preventDefault();
    el.click();
  });

  // 4.1.2 Paneler som temat visar och döljer med aria-hidden, men vars
  // knappar och länkar gick att tabba till även när de var dolda.
  var PANELS = ".product-module__sticky-atc, notify-me-popup";
  function syncPanel(el) {
    el.inert = el.getAttribute("aria-hidden") === "true";
  }

  // När Notify me öppnas sätter temat aria-hidden="false" och flyttar fokus
  // in i popupen i samma ögonblick - innan observern ovan hinner ta bort
  // inert. Spärren lyfts därför redan vid klicket, i capture-fasen, som
  // körs före temats egen klickhantering.
  window.addEventListener(
    "click",
    function (event) {
      if (!event.target.closest || !event.target.closest('[data-action="notify-open"]')) return;
      var popups = document.querySelectorAll("notify-me-popup");
      for (var i = 0; i < popups.length; i++) popups[i].inert = false;
    },
    true,
  );

  // 4.1.2 Favorithjärtat på produktkort: temat sätter state="active" när
  // produkten är favorit. Skärmläsaren ska få veta det.
  function syncFavorite(el) {
    el.setAttribute("aria-pressed", el.getAttribute("state") === "active" ? "true" : "false");
  }

  // 4.1.2 Sidfotens menyer. Temat visar innehållet med aria-hidden="false"
  // och döljer det med "true" - attributet styr alltså synligheten i CSS och
  // får aldrig tas bort. På dator (från 1025 px) visas innehållet alltid,
  // men attributet stod kvar på "true", så skärmläsare hoppade över länkar
  // som syntes och gick att tabba till.
  var desktop = window.matchMedia("screen and (min-width: 1025px)");

  function syncFooter() {
    var dropdowns = document.querySelectorAll(".footer__dropdown");
    for (var i = 0; i < dropdowns.length; i++) {
      var button = dropdowns[i].querySelector(".footer__dropdown-button");
      var content = dropdowns[i].querySelector(".footer__dropdown-content");
      if (!button || !content) continue;

      if (desktop.matches && button.getAttribute("aria-expanded") !== "true") {
        button.setAttribute("aria-expanded", "true");
      }
      var open = desktop.matches || button.getAttribute("aria-expanded") === "true";
      var wanted = open ? "false" : "true";
      if (content.getAttribute("aria-hidden") !== wanted) content.setAttribute("aria-hidden", wanted);
      // Hopfällt innehåll ska inte heller gå att tabba in i.
      content.inert = !open;
    }
  }

  function start() {
    syncFooter();
    if (desktop.addEventListener) desktop.addEventListener("change", syncFooter);

    var buttons = document.querySelectorAll(".footer__dropdown-button");
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        var expanded = m.target.getAttribute("aria-expanded") === "true";
        // Vid stängning: vänta in temats animation (300 ms) innan
        // innehållet döljs, annars försvinner det utan att glida ihop.
        if (expanded) syncFooter();
        else setTimeout(syncFooter, 350);
      });
    });
    for (var i = 0; i < buttons.length; i++) {
      observer.observe(buttons[i], { attributes: true, attributeFilter: ["aria-expanded"] });
    }

    // Produktkort laddas också in senare (filter, fler produkter), så
    // hjärtan följs upp när de dyker upp.
    var hearts = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "attributes") syncFavorite(m.target);
        m.addedNodes &&
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            var found = node.matches(".product-card__favorites-icon")
              ? [node]
              : node.querySelectorAll(".product-card__favorites-icon");
            for (var j = 0; j < found.length; j++) syncFavorite(found[j]);
          });
      });
    });
    hearts.observe(document.body, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["state"],
    });
    var initial = document.querySelectorAll(".product-card__favorites-icon");
    for (var k = 0; k < initial.length; k++) syncFavorite(initial[k]);

    var panels = document.querySelectorAll(PANELS);
    var panelObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        syncPanel(m.target);
      });
    });
    for (var p = 0; p < panels.length; p++) {
      syncPanel(panels[p]);
      panelObserver.observe(panels[p], { attributes: true, attributeFilter: ["aria-hidden"] });
    }
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
